// extracted by mini-css-extract-plugin
export var list = "DashboardMenu-module--list--FOCck";
export var icon = "DashboardMenu-module--icon--ye0PK";
export var symbol = "DashboardMenu-module--symbol--gjw68";
export var content = "DashboardMenu-module--content--JC4tV";
export var title = "DashboardMenu-module--title--q5PkO";
export var description = "DashboardMenu-module--description--awXGt";
export var link = "DashboardMenu-module--link--7-GdG";
export var primary = "DashboardMenu-module--primary--rN-Ad";
export var secondary = "DashboardMenu-module--secondary--Kf5Ye";
export var compact = "DashboardMenu-module--compact--rDpyy";